<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <div>查询条件</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="storeOrderCartReturnInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="storeOrderCartReturnInfo.conditions.cartId" placeholder="订单编号" clearable />
          </el-form-item>
          <el-form-item>
            <el-select v-model="storeOrderCartReturnInfo.conditions.state" placeholder="请选择状态" style="width:100%"
              clearable>
              <el-option v-for="item in storeOrderCartReturnInfo.states" :key="item.statusCd" :label="item.name"
                :value="item.statusCd" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="storeOrderCartReturnInfo.conditions.prodNameLike" placeholder="请输入商品名称" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="_queryOrdersMethod">查询</el-button>
            <el-button type="primary" icon="el-icon-refresh" @click="_resetOrdersMethod">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <div>退货订单</div>
        <div class="card-header-right">
          <el-button type="primary" icon="el-icon-plus" @click="_applyReturnOrderCart">商品退货</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="_applyReturnOrder">订单退货</el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="storeOrderCartReturnInfo.orderCarts" border style="width: 100%">
          <el-table-column prop="cartId" label="订单号" align="center" />
          <el-table-column prop="prodName" label="商品名称" align="center" />
          <el-table-column prop="personName" label="用户名称" align="center" />
          <el-table-column prop="returnPayPrice" label="退款金额" align="center" />
          <el-table-column prop="stateName" label="订单状态" align="center" />
          <el-table-column prop="returnReason" label="退款原因" align="center" />
          <el-table-column prop="createTime" label="申请时间" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.state == '1001'" type="text" size="small"
                @click="_openAuditReturnOrderCartModel(scope.row)">审核</el-button>
              <el-button type="text" size="small" @click="_openOrderDetailModel(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="storeOrderCartReturnInfo.conditions.page" :page-sizes="[10, 20, 30, 50]"
          :page-size="storeOrderCartReturnInfo.conditions.row" layout="total, sizes, prev, pager, next, jumper"
          :total="storeOrderCartReturnInfo.total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </el-card>

    <audit ref="audit" @auditNotify="_doOpenAuditReturnOrderCartModel" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryRefundOrders, auditStoreOrderCartReturn } from '@/api/order/storeOrderCartReturnApi'

export default {
  name: 'StoreOrderCartReturn',
  components: {
    Audit: () => import('@/components/common/audit/Audit')
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      storeOrderCartReturnInfo: {
        orderCarts: [],
        total: 0,
        records: 1,
        orderDetail: false,
        states: [],
        conditions: {
          cartId: '',
          state: '',
          prodNameLike: '',
          shopId: '',
          page: 1,
          row: 10
        },
        curOrderCart: {}
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      this.storeOrderCartReturnInfo.conditions.shopId = getShopId()
      await this._listOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      try {
        const { data } = await getDict('store_order_cart_return', 'state')
        this.storeOrderCartReturnInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listOrders(page, rows) {
      this.storeOrderCartReturnInfo.conditions.page = page
      this.storeOrderCartReturnInfo.conditions.row = rows
      this.storeOrderCartReturnInfo.conditions.shopId = getShopId()

      const params = {
        ...this.storeOrderCartReturnInfo.conditions,
        cartId: this.storeOrderCartReturnInfo.conditions.cartId.trim(),
        state: this.storeOrderCartReturnInfo.conditions.state.trim(),
        prodName: this.storeOrderCartReturnInfo.conditions.prodNameLike.trim()
      }

      try {
        const res = await queryRefundOrders(params)
        this.storeOrderCartReturnInfo.total = res.total
        this.storeOrderCartReturnInfo.records = res.records
        this.storeOrderCartReturnInfo.orderCarts = res.data
      } catch (error) {
        console.log('请求失败处理', error)
      }
    },
    _queryOrdersMethod() {
      this._listOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetOrdersMethod() {
      this.storeOrderCartReturnInfo.conditions.cartId = ''
      this.storeOrderCartReturnInfo.conditions.state = ''
      this.storeOrderCartReturnInfo.conditions.prodName = ''
      this._listOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _openOrderDetailModel(order) {
      this.$router.push(`/pages/goods/storeOrderCartDetail?orderId=${order.orderId}&cartId=${order.cartId}`)
    },
    _openAuditReturnOrderCartModel(order) {
      this.storeOrderCartReturnInfo.curOrderCart = order
      this.$refs.audit.open()
    },
    async _doOpenAuditReturnOrderCartModel(param) {
      const data = {
        state: param.state,
        message: param.remark,
        returnId: this.storeOrderCartReturnInfo.curOrderCart.returnId,
        shopId: getShopId()
      }

      try {
        const res = await auditStoreOrderCartReturn(data)
        if (res.code === 0) {
          this.$message.success('审核成功')
          this._listOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
          return
        }
        this.$message.error(res.msg)
      } catch (error) {
        console.log('请求失败处理', error)
      }
    },
    _applyReturnOrderCart() {
      this.$router.push('/pages/goods/applyReturnOrderrCartManage')
    },
    _applyReturnOrder() {
      this.$router.push('/pages/goods/applyReturnOrderManage')
    },
    handleSizeChange(val) {
      this.storeOrderCartReturnInfo.conditions.row = val
      this._listOrders(this.storeOrderCartReturnInfo.conditions.page, val)
    },
    handleCurrentChange(val) {
      this._listOrders(val, this.storeOrderCartReturnInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-header-right {
  float: right;
  padding: 3px 0;
}
</style>